import { type ComponentProps, type FC, type MouseEventHandler } from "react";
import { Link } from "@root/shared/components/Link";

type Props = {
  query?: string;
  text: string;
  className?: string;
  size?: ComponentProps<typeof Link>["size"];
  // firebaseActionはwebviewでfirebaseイベント送信のために使用する。classNameに.firebase-clickがある場合にのみ機能する。
  firebaseAction?: string;
  firebaseActionType?: string;
  firebaseEventGeneratedPart?: string;
  url: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  gaAction?: string;
  gaLabel?: string;
};

export const EntryLink: FC<Props> = ({
  query,
  text,
  className,
  size,
  firebaseAction,
  firebaseActionType,
  firebaseEventGeneratedPart,
  url,
  onClick,
  gaAction,
  gaLabel,
}) => {
  return (
    <Link
      theme="primary"
      className={className}
      href={url}
      size={size}
      onClick={onClick}
      data-ga-action={gaAction}
      data-ga-label={gaLabel}
      data-query-str={query}
      {...(firebaseAction
        ? {
            "data-firebase-action": firebaseAction,
            "data-firebase-view-type": "screen_view",
            "data-firebase-action-type": firebaseActionType,
            "data-firebase-event-generated-part": firebaseEventGeneratedPart,
          }
        : {})}
    >
      {text}
    </Link>
  );
};
